import { Box, styled } from "@mui/material";

// Independent copy of the card wrapper — changes to the Coulomb version
// (src/PagesContent/Overview/components/StyledComponents) will not affect this.
export const StyledCard = styled(Box)(() => ({
    backgroundColor: '#FFFFFF',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid #E9E9E9',
    width: '100%',
}));
